import React, { useEffect } from 'react';
import { Shield, Database, Scale, ScrollText } from 'lucide-react';

export default function Terms() {
  // Scroll to top when the page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        
        {/* Header Section */}
        <div className="bg-slate-900 px-8 py-10 text-center border-b-4 border-yellow-500">
          <Shield className="w-12 h-12 text-yellow-400 mx-auto mb-4" />
          <h1 className="text-3xl font-extrabold text-white tracking-tight sm:text-4xl">
            Terms of Service & Data Policy
          </h1>
          <p className="mt-2 text-slate-400 font-medium">
            Effective Date: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
          </p>
        </div>

        {/* Content Section */}
        <div className="px-8 py-10 text-slate-700 space-y-8 leading-relaxed">
          
          <section>
            <h2 className="text-xl font-bold text-slate-900 flex items-center gap-2 mb-4">
              <ScrollText className="w-5 h-5 text-yellow-500" />
              1. General Terms
            </h2>
            <p>
              Welcome to Tool Deals Daily. By accessing or using our website, you agree to be bound by these Terms of Service. 
              Tool Deals Daily is operated by <strong>Greenwood Valley Ventures LLC</strong>. We aggregate and curate tool deals, 
              pricing history, and product information for informational purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 flex items-center gap-2 mb-4">
              <Database className="w-5 h-5 text-blue-500" />
              2. AI, Scraping & Automated Access Policy
            </h2>
            <ul className="list-disc pl-5 space-y-3">
              <li>
                <strong>Intellectual Property & Data Ownership:</strong> All data, including but not limited to product pricing, historical price trends, curator notes ("Expert Insights"), and database structures hosted on tooldealsdaily.com, are the sole property of Greenwood Valley Ventures LLC.
              </li>
              <li>
                <strong>Permitted Automated Access:</strong> Currently, we allow automated "crawlers" and "bots" (such as those from search engines and AI platforms) to access the site for the sole purpose of indexing and displaying Tool Deals Daily as a source in search results.
              </li>
              <li>
                <strong>Prohibited Use:</strong> Direct scraping of the database for the purpose of replicating the platform, creating a competing service, or bulk data harvesting without express written consent is strictly prohibited.
              </li>
              <li>
                <strong>AI & LLM Training:</strong> Any AI-generated response utilizing data from this site must clearly cite Tool Deals Daily as the source. Any commercial use of our structured data to train, fine-tune, or provide real-time inputs for AI models beyond standard search indexing requires a separate commercial data-licensing agreement.
              </li>
              <li>
                <strong>Right to Restrict Access:</strong> We reserve the right to restrict, rate-limit, or "paywall" automated access at any time using any technical or administrative means necessary to protect our infrastructure and proprietary data.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 flex items-center gap-2 mb-4">
              <Scale className="w-5 h-5 text-red-500" />
              3. Affiliate Disclosure
            </h2>
            <p>
              Tool Deals Daily is a participant in various affiliate programs, including the Amazon Services LLC Associates Program 
              and Impact.com networks. We may earn a commission on qualifying purchases made through links on our site at no 
              additional cost to you. Pricing and availability are subject to change by the retailer.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">
              4. Future Modifications
            </h2>
            <p>
              Greenwood Valley Ventures LLC reserves the right to update these terms and implement new technical access controls to restrict unauthorized scraping as the platform evolves. Continued use of the site or its data constitutes acceptance of the most current terms.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}